import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class ArOtherChargeService extends ApiService {
  template = "defaultTemplate";
  namespace = "service";
  icon = "RedCreditCard";
  action = "action";
  name = "Other Charge";
  favicon = "CreditCardRed";
  action_lable = this.t("Inactivate");
  Width = 1200;
  DOMAIN = DOMAIN.OTHER_CHARGE;
  singular = this.terminology.otherCharge.singular;
  plural = this.terminology.otherCharge.plural;
  vowel = this.terminology.otherCharge.vowel;
  search = true;

  gemItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.LIST,
    },
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.RED_CREDIT_CARD,
      field: "display_name",
    },
    {
      header: "Numbers",
      icon: AppIcons.SHRED,
      field: "Number",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Good...",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  constructor() {
    super("ar-other-charges");
  }
}
